import moment from "moment";
export const dateFormat: string = "YYYY-MM-DD";

export const minDate: string = moment().startOf('year').format(dateFormat);
export const maxDate: string = moment().endOf('year').format(dateFormat);
